// Generated by scripts/generate-build-info.js (prebuild). Do not edit.
export const APP_VERSION = '6f1518be';
